module.exports = __webpack_public_path__ + "static/media/Car.22f7f4a2.svg";